import { useQuery } from 'react-query';
import { ProfileInfo } from 'src/core/types';

import axios from './axios';

export function useUser(id: number) {
  return useQuery<ProfileInfo>(['user', id], async () => {
    return axios
      .get<ProfileInfo>(`/posht/ashena/users/${id}/`)
      .then((res) => res.data);
  });
}
